import { Loadable } from 'utils/components';
import { PIXELBAY_PATH as path } from 'constants/paths';

export default {
  path,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'PixelBay' */ './components/PixelBayPage')
  })
};
